import * as Actions from "../constant/ActionTypes";

export const rbacDataAction = (data) => async (dispatch) => {
    try {
        dispatch({
            type: Actions.RBAC_DATA,
            payload: data
        });
    } catch (error) {
        console.log(error);
    }
}
